import { Component, OnDestroy, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { interval, Subscription } from "rxjs";
import {
  GuidePermissionKey,
  GuidePermissionState,
  PermissionManagerService,
} from "src/app/_services/permission-manager.service";

@Component({
  selector: "app-permission-modal",
  templateUrl: "./permission-modal.component.html",
  styleUrls: ["./permission-modal.component.scss"],
})
export class PermissionModalComponent implements OnInit, OnDestroy {
  state: GuidePermissionState | null = null;
  refreshing = false;
  private pollSub?: Subscription;

  permissionItems: Array<{
    key: GuidePermissionKey;
    title: string;
    description: string;
    icon: string;
    buttonLabel: string;
  }> = [
    {
      key: "location",
      title: "PERMISSIONS.STEPPER.LOCATION_TITLE",
      description: "PERMISSIONS.STEPPER.LOCATION_DESCRIPTION",
      icon: "navigate",
      buttonLabel: "PERMISSIONS.STEPPER.ACTION_LOCATION",
    },
    {
      key: "notifications",
      title: "PERMISSIONS.STEPPER.NOTIFICATIONS_TITLE",
      description: "PERMISSIONS.STEPPER.NOTIFICATIONS_DESCRIPTION",
      icon: "notifications",
      buttonLabel: "PERMISSIONS.STEPPER.ACTION_NOTIFICATIONS",
    },
    {
      key: "battery",
      title: "PERMISSIONS.STEPPER.BATTERY_TITLE",
      description: "PERMISSIONS.STEPPER.BATTERY_DESCRIPTION",
      icon: "battery-charging",
      buttonLabel: "PERMISSIONS.STEPPER.ACTION_BATTERY",
    },
  ];

  constructor(
    private permissionManager: PermissionManagerService,
    private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.refreshState(true);
    this.pollSub = interval(30000).subscribe(() => this.refreshState());
  }

  ngOnDestroy(): void {
    this.pollSub?.unsubscribe();
  }

  async refreshState(_initial = false): Promise<void> {
    if (this.refreshing) return;
    this.refreshing = true;
    try {
      this.state = await this.permissionManager.checkPermissionState();
    } finally {
      this.refreshing = false;
    }
  }

  async handleAction(type: GuidePermissionKey): Promise<void> {
    await this.permissionManager.requestPermission(type);
    setTimeout(() => this.refreshState(), 500);
  }

  permGranted(key: GuidePermissionKey): boolean {
    if (!this.state) return false;
    return this.permissionManager.isGranted(key, this.state);
  }

  dismiss(): void {
    this.modalCtrl.dismiss({ completed: true }, "completed");
  }

  trackByKey(index: number, item: { key: GuidePermissionKey }): string {
    return item.key + index;
  }

  getGrantedCount(): number {
    return this.permissionItems.filter((item) => this.permGranted(item.key)).length;
  }

  getTotalCount(): number {
    return this.permissionItems.length;
  }

  getProgressPercentage(): number {
    if (this.getTotalCount() === 0) return 100;
    return Math.round((this.getGrantedCount() / this.getTotalCount()) * 100);
  }
}
